module.exports = __webpack_public_path__ + "img/outlander2022_seat.f505a95b.jpg";